<template>
  <div id="Consolenew_AD" class="Consolenew">
    <el-row>
      <el-col :span="15">
        <!-- <el-image :src="searchform.src"></el-image> -->
        <div class="imagedata">
          <div class="image-box"></div>
          <el-image :src="ADIndex.AD_Pic_Url"></el-image>
        </div>
      </el-col>
      <el-col :span="9">
        <div class="text-box">
          <el-form :label-position="labelPosition" label-width="80px">
            <el-form-item label="媒体编号:">{{ADIndex.LightBox_Code}}</el-form-item>
            <el-form-item label="媒体位置:">{{ADIndex.LightBox_Address}}</el-form-item>
            <el-form-item label="广告名称:">{{ADIndex.AD_Title}}</el-form-item>
            <el-form-item label="更换日期:">{{ADIndex.Start_Date}}</el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "consolenew_ad",
  props:{
			ADId: {
				type:Number,
				default:1
            }
        },
  data: function() {
    return {
      fullscreenLoading: false,
      labelPosition: "right",
       searchform: {
                AdId: "",
            },
      ADIndex:{
              AD_Title: "年终大促",
              AD_Content: "年终大促",
              AD_Desc: "年终大促",
              Start_Date: "2020-01-01",
              End_Date: "2020-12-30",
              AD_Pic_Url: "http://172.31.1.104:8011/upload/Ad1.png",
              LightBox_Code: "AIGUO-B10001",
              LightBox_Address: "B1层拐角左墙",
              LightBox_Desc: "立式道路展示灯箱"
            },
    };
  },
  watch: {
       ADId:function (newADId, oldADId) {
        this.initData();
        } 
    },
  methods: {

    initData() {
      var loading = this.$loading({
            target:document.querySelector('.Consolenew'),
            fullscreen:false,
						text: '广告加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
      var Vuethis=this;
        this.$hrraxios.get(this.$api.AD.getAD+"/"+this.ADId)
        .then(function (response) {
          loading.close();
					var data=response.data;
					if(data.Success==true)
					{
            Vuethis.ADIndex.AD_Pic_Url=data.Data.AD_Pic_Url;
            Vuethis.ADIndex.LightBox_Code=data.Data.LightBox_Code;
            Vuethis.ADIndex.LightBox_Address=data.Data.LightBox_Address;
            Vuethis.ADIndex.AD_Title=data.Data.AD_Title;
            Vuethis.ADIndex.Start_Date=data.Data.Start_Date.replace(/\s[\x00-\xff]*/g,'');
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
          loading.close();
					console.log(error);
				});
    },
    initParamsData() {}
  },
  created() {
    this.initData();
    this.initParamsData();
  }
};
</script>
<style>
#Consolenew_AD {
  background: url("../../assets/AD_bg.png") no-repeat;
  background-size: 100% 100%;
  margin-top: -45px;
  margin-left: -17px;
  height: 35%;
}

.imagedata { 
    position: relative;
    margin-top: 12%;
    margin-left: 10%;
    height: 75%;
}
.imagedata .el-image{
  width:100%;
  height:100%;
}
.image-box {
  position: absolute;
  box-sizing: border-box;
  z-index: 1;
  width: 100%;
  height: 100%;
  border: 13px solid rgb(0, 0, 0, 0.4);
}
.text-box {
  width: 97%;
  height: 73%;
  margin-top: 30%;
  overflow: overlay;
}
.text-box .el-form-item {
  margin-bottom: 12px !important;
}
.text-box .el-form-item__label {
    font-size: 1.8vh !important;
    color: white !important;
    width: 43% !important;
    line-height: 1.8 !important;
}
.text-box .el-form-item__content {
  font-size: 1.8vh !important;
  color: white !important;
  word-break: break-all;
  margin-left: 43% !important;
  line-height: 1.8 !important;
}
.text-box::-webkit-scrollbar {
  /*滚动条整体样式*/
    width : 3px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 3px;
  }
.text-box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    background   : rgba(0, 0, 0, 0.5);
  }
.text-box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
    box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background-color: rgba(255,255,255,0.5);
  }
</style>